import { render, staticRenderFns } from "./BurgerMenuItem.vue?vue&type=template&id=29c31c58"
import script from "./BurgerMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./BurgerMenuItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports